export default Object.freeze({
  ChangeFrequencyDurationModality: 1,
  SpecialistChangedEliminatedOrAdded: 4,
  ChangePlaceOfService: 7,
  AEE: 8,
  ModifyOrAddContractor: 15,
});
